import orderLogQueries from '@apis/queries/orderLogQueries';
import useToast from '@hooks/ui/useToast';
import { useFlow } from '@stackflow/react';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

function useOrderLog(orderNo: string) {
    const { data, status } = useQuery(orderLogQueries.detail(orderNo));
    const { pop } = useFlow();
    const toast = useToast();
    useEffect(() => {
        if (status === 'error') {
            toast.error('주문 내역을 불러오지 못했습니다.');
            pop();
        }
    }, [status]);
    const isLoading = status === 'pending';
    return {
        orderLog: data,
        isLoading,
    };
}

export default useOrderLog;
